import _color from '@/assets/utils/color.js';
<template>
  <div
    class="mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."
  >
    <vx-card>
      <div class="vx-row mt-2" v-if="acstate == 'EDIT'">
        <div class="vx-col mt-3" style="width: 200px; text-align: right">
          <span>Number</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <vs-input
            class="w-3/5"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="number"
            :readonly="true"
          />
        </div>
      </div>

      <div class="inline-flex w-4/5 pb-2 mt-6" v-if="acstate == 'ADD'">
        <div class="column is-narrow" style="width: 200px; text-align: right">
          <span>Invoice Number</span>
        </div>
        <div style="width: 450px">
          <vx-input-group>
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              v-model="refInvoiceNumber"
              :readonly="true"
            />

            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button
                  color="#5b3cc4"
                  type="filled"
                  icon="search"
                  @click="searchInb"
                  >ดึงข้อมูล Invoice</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>CreditNote Reason</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="refInvoiceReason"
            @blur="$v.refInvoiceReason.$touch()"
          />
          <p v-if="$v.refInvoiceReason.$error & $v.refInvoiceReason.$dirty">
            Please Enter Required Data
          </p>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col mt-8" style="width: 200px; text-align: right">
          <span>Remark</span>
        </div>
        <div class="vx-col mt-5 sm:w-2/4 w-1/2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            v-model="remark"
          />
        </div>
      </div>

      <div class="vx-row mt-8">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="onSubmit">Submit</vs-button>
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>

    <vs-popup fullscreen title="Invoice Number" :active.sync="popupActive6">
      <invoices
        v-if="popupActive6"
        :companyGroupsCode="companyGroupsCode"
        @recsel="recsel"
      ></invoices>
    </vs-popup>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import invoices from "./invoicesgrid.vue";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      refInvoiceReason: "",
      whtDate: "",
      number: "",
      refInvoiceNumber: "",
      businessPartnersCode: "",
      customers: [],
      paymentTerm: 0,
      paymentType: "",
      remark: "",
      postState: "",
      readonly: false,
      popupActive6: false,
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
    };
  },
  validations: {
    refInvoiceReason: {
      required,
    },
  },
  components: {
    invoices,
  },
  props: ["acstate", "recid"],
  methods: {
    searchInb() {
      // console.log("inb");
      this.popupActive6 = true;
    },
    async recsel(val) {
      this.refInvoiceNumber = val;
      // console.log(this.inbordersNumber);
      // console.log(val);

      this.popupActive6 = false;

      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: `Confirm`,
        text: "ยืนยันการสร้างรายการจาก Invoice? ",
        accept: this.acceptCharge,
      });
    },
    async acceptCharge() {
      // alert(this.refInvoiceNumber)
      
      if (this.refInvoiceReason == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "เหตุผลในการยกเลิก ไม่สามารถว่างได้ โปรดตรวจสอบ",
          text: "Please check the Status",
          fixed: true,
        });
        return;
      }

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        refInvoiceNumber: this.refInvoiceNumber,
        refInvoiceReason: this.refInvoiceReason,
        remark: this.remark,
        editor: String(this.userid),
      };

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/cninvoices/createItem`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data)

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Create Item Complete",
              text: response.data.message,
            });
            this.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    clsd: function () {
      this.remark = "";
      let vm = this;

      vm.$emit("grid");
    },
    async onSubmit() {
      // alert("Hi");
      let vm = this;

      if (this.postState == "COMPLETE") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Status POST COMPLETE ไม่สามารถแก้ไขได้",
          text: "Please check the Status",
          fixed: true,
        });
        return;
      }

      if (this.refInvoiceNumber == "") {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "ไม่พบ Invoice Number",
          text: "Please check the Status",
          fixed: true,
        });
        return;
      }

      const formData = {
        acstate: this.acstate,
        companyGroupsCode: this.companyGroupsCode,
        number: this.recid,
        businessPartnersCode: this.businessPartnersCode,
        refInvoiceNumber: this.refInvoiceNumber,
        refInvoiceReason: this.refInvoiceReason,
        remark: this.remark,
        editor: String(this.userid),
      };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/billing-svc/cninvoices/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
            vm.clsd();
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }

      // vm.$emit("grid");
      // vm.clsd();
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        try {
          // const response = await axios.get(`${BASE_API_URL}/auth/profile`, {
          //   headers: { Authorization: "Bearer " + token.accessToken }
          // });

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          // this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
          // console.log(decoded);
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
  },
  async created() {
    // console.log(this.recid);
    // console.log("create");
    this.checkProfiles();

    if (this.recid != "0") {
      // alert("Edit");
      try {
        this.readonly = true;
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const response = await axios.get(
          `${BASE_API_URL}/billing-svc/cninvoices/${this.recid}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.number = response.data.number;
          this.refInvoiceReason = response.data.refInvoiceReason;
          this.refInvoiceNumber = response.data.refInvoiceNumber;
          this.remark = response.data.remark;
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
